export const SET_ATTACHMENTYPE = 'RSVP/SET_ATTACHMENTYPE'
export const SET_ATTACHMENTYPES = 'RSVP/SET_ATTACHMENTYPES'
